export const DisplayReport = [
    {Id: 'Yearly', Name: 'Yearly'},
    {Id: 'Quarterly', Name: 'Quarterly'},
    {Id: 'Monthly', Name: 'Monthly'},
    {Id: 'Weekly', Name: 'Weekly'},
    {Id: 'Daily', Name: 'Daily'}
]
